const QUESTIONSDATAHINDI = [
    {
        id: 1,
        question: `संपत पाल देवी ने बुंदेलखंड में महिलाओं के खिलाफ होने वाली हिंसा को रोकने के लिए किस दल की स्थापना की थी?`,
        option1: `लक्ष्मीबाई सेना`,
        option2: `गुलाबी गैंग`,
        option3: `नारी मुक्ति वाहिनी`,
        option4: `महिला मोर्चा`,
        correct: `गुलाबी गैंग`,
        correctOpt: `B`
    },
    {
        id: 2,
        question: "इनमें से किस बीमारी को 'दिमागी बुखार' के नाम से भी जाना जाता है ?",
        option1: "जापानी इन्सेफेलाइटिस",
        option2: "टेटनस",
        option3: "डेंगू",
        option4: "रेबीज़",
        correct: "जापानी इन्सेफेलाइटिस",
        correctOpt: `A`
    },
    {
        id: 3,
        question: "कैंडी क्रश सागा, टेंपल रन और फ्रूट निंजा किसके प्रकार हैं ?",
        option1: "चैट मैसेंजर",
        option2: "एंटी वायरस",
        option3: "गेम्स",
        option4: "सर्च इंजन",
        correct: "गेम्स",
        correctOpt: `C`
    },
    {
        id: 4,
        question: `फिल्म 'हीरोपंती' से फिल्मो में बतौर नायक कदम रखने वाले टाइगर किस अभिनेता के बेटे हैं ?`,
        option1: `सुनील शेट्टी`,
        option2: `जैकी श्रॉफ`,
        option3: `सनी देओल`,
        option4: `अनिल कपूर`,
        correct: `जैकी श्रॉफ`,
        correctOpt: `B`
    },
    {
        id: 5,
        question: "भारत में इनमें से कौनसा पद एक निर्वाचित पद है ?",
        option1: "भारत के मुख्य न्यायाधीश",
        option2: "मुख्य चुनाव आयुक्त",
        option3: "भारत के राष्ट्रपति",
        option4: "राज्यपाल",
        correct: "भारत के राष्ट्रपति",
        correctOpt: `C`
    },
    {
        id: 6,
        question: "इनमें से कौन रामायण के मुख्य पात्रों में से एक हैं जो महाभारत में भी नजर आतें हैं ?",
        option1: "हनुमान",
        option2: "वेदव्यास",
        option3: "दशरथ",
        option4: "दुर्योधन",
        correct: "हनुमान",
        correctOpt: `A`
    },
    {
        id: 7,
        question: "हमारे सौर मंडल में सबसे बड़ी वस्तु क्या है ?",
        option1: "टाइटन",
        option2: "जुपिटर",
        option3: "सन",
        option4: "अल्फ़ा सेंटौरी",
        correct: "जुपिटर",
        correctOpt: `B`
    },
    {
        id: 8,
        question: " दागा और तेजा किस फ़िल्मी विलेन के चेले थे ?",
        option1: "मगेम्बो",
        option2: "गब्बर सिंह",
        option3: "कांचा चीना",
        option4: "शाकाल",
        correct: "मगेम्बो",
        correctOpt: `A`
    },
    {
        id: 9,
        question: "इनमें से क्या भारतीय राष्ट्रीय कैलेंडर के एक महीने का नाम है ?",
        option1: "आषाढ़",
        option2: "नक्षत्र",
        option3: "द्वादश",
        option4: "पूर्णिमा",
        correct: "आषाढ़",
        correctOpt: `A`
    },
    {
        id: 10,
        question: "वीणापाणी किस देवी का एक और नाम है ?",
        option1: "दुर्गा",
        option2: "सरस्वती",
        option3: "सीता",
        option4: "लक्ष्मी",
        correct: "सरस्वती",
        correctOpt: `B`
    },
    {
        id: 11,
        question: "अर्थव्यवस्था के सन्दर्भ में प्रत्यक्ष और अप्रत्यक्ष इनमें से क्या है ?",
        option1: "कर",
        option2: "बैंक खाता",
        option3: "घाटा",
        option4: "मुद्रास्फीति",
        correct: "कर",
        correctOpt: `A`
    },
    {
        id: 12,
        question: "इनमें से कौन सा मसाला वास्तव में सूखी पत्तियां होती हैं ?",
        option1: "कलौंजी",
        option2: "जावित्री",
        option3: "दालचीनी",
        option4: "कसूरी मेथी",
        correct: "कसूरी मेथी",
        correctOpt: `D`
    },
    {
        id: 12,
        question: "किस शहर का नाम बदलकर गुरुग्राम रख दिया गया है ?",
        option1: "गुड़गांव",
        option2: "गंगानगर",
        option3: "गुवाहाटी",
        option4: "गंगटोक",
        correct: "गुड़गांव",
        correctOpt: `A`
    },
    {
        id: 13,
        question: "इनमे से किस खेल जगत के शक्शियत पर अब तक कोई फीचर फिल्म नहीं बनी है ?",
        option1: "मैरी कॉम",
        option2: "सानिया मिर्जा",
        option3: "मिल्खा सिंह",
        option4: "महेंद्र सिंह धोनी",
        correct: "सानिया मिर्जा",
        correctOpt: `B`
    },
    {
        id: 14,
        question: "माघ के महीने में किस दिन मनाया जाता है जिसमें भक्त ‘मौन व्रत’ का पालन करते हैं?",
        option1: "प्रतिपदा",
        option2: "एकदशी",
        option3: "अमावस्या",
        option4: "पूर्णिमा",
        correct: "अमावस्या",
        correctOpt: `C`
    },
    {
        id: 15,
        question: "इन तीर्थ स्थलों में से कौन सा समुद्र के सबसे निकट है?",
        option1: "द्वारका",
        option2: "अमरनाथ",
        option3: "बोध गया",
        option4: "उज्जैन",
        correct: "द्वारका",
        correctOpt: `A`
    },
    {
        id: 16,
        question: "इन खेलों में से किस टीम का ‘ऑल आउट’ और ‘न आउट’ टीम का इस्तेमाल किया जाता है?",
        option1: "बैडमिंटन",
        option2: "कबड्डी",
        option3: "हॉकी",
        option4: "फुटबाल",
        correct: "कबड्डी",
        correctOpt: `B`
    }
]
export default QUESTIONSDATAHINDI;